import classNames from "classnames";
import "./ContentCenter.css";

export type Props = {
    className?: string;
    children: React.ReactNode;
};

type BaseContentCenter = (className?: string) => (props: Props) => React.ReactNode;

function BaseContentCenter(baseClassName?: string) {
    return function Center(props: Props) {
        const { className, children } = props;
        return (
            <div
                className={classNames(
                    "web-lib__content-wrapper",
                    baseClassName,
                    className,
                )}
            >
                {children}
            </div>
        );
    };
}

const Sizes = (baseContentCenter: BaseContentCenter) =>
    Object.assign(baseContentCenter(), {
        Large: baseContentCenter("web-lib__content-wrapper--large"),
        Medium: baseContentCenter("web-lib__content-wrapper--medium"),
        Small: baseContentCenter("web-lib__content-wrapper--small"),
    });

const ContentCenter = Sizes(BaseContentCenter);

export default ContentCenter;
